module.exports = __webpack_public_path__ + "media/icons/arrow-down-black-1876a7c0.png";